import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { http } from "../lib/api";
import { useAuth, apiError } from "../context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    http
      .post("/auth/google/session", { session_id: sid })
      .then((r) => {
        setUser(r.data);
        navigate(location.pathname === "/" ? "/account" : location.pathname, { replace: true, state: { user: r.data } });
      })
      .catch((e) => {
        toast.error(apiError(e));
        setUser(false);
        navigate("/login", { replace: true });
      });
  }, [location, navigate, setUser]);

  return <div className="min-h-screen bg-white" />;
}
